export default {
  DECLINED: 'declined',
  AWAIT_RESULT: 'await_result',
  APPLICANT_INFO: 'applicant_info',
  APPLICANT_INFO_MAJOR_SUBJECTS :'applicant_info_major_subjects',
  APPLICANT_FIRST_PREFERRED_SUBJECT :'applicant_first_preferred_subject',
  APPLICANT_INFO_SECOND_SUBJECTS :'applicant_info_second_subjects',
  ESSAY_WELCOME :'essay_welcome',
  LANGUAGE_TEST_FAILED :'language_test_failed',
  SUBJECT_TEST_FAILED :'subject_test_failed',
  PHONE_VERIFICATION :'phone_verification',
  SUBJECT_TEST_SUCCESS :'subject_test_success',
  SUBJECT_ESSAY_1: 'subject_essay_1',
}



// WEBPACK FOOTER //
// ./src/constants/profileStages.js